import { render, staticRenderFns } from "./UniappVersion.vue?vue&type=template&id=7d6c4ec9&"
import script from "./UniappVersion.vue?vue&type=script&lang=js&"
export * from "./UniappVersion.vue?vue&type=script&lang=js&"
import style0 from "./UniappVersion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports